import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { ExternalLink } from "lucide-react";
import { AnimatedSection } from "@/components/AnimatedSection";
import { Button } from "@/components/ui/button";

// Project-specific images
import claroArena from "@/assets/projects/claro-arena.webp";
import decathlon from "@/assets/projects/decathlon.webp";
import duocUc from "@/assets/projects/duoc-uc.jpg";
import duocCentroMinero from "@/assets/projects/duoc-centro-minero.jpg";
import duocMelipilla from "@/assets/projects/duoc-melipilla.webp";
import duocPlazaVespucio from "@/assets/projects/duoc-plaza-vespucio.webp";
import duocNacimiento from "@/assets/projects/duoc-nacimiento.jpg";
import duocPuertoMontt from "@/assets/projects/duoc-puerto-montt.jpg";
import duocMaipu from "@/assets/projects/duoc-maipu.webp";
import komatsu from "@/assets/projects/komatsu.jpeg";
import abcdin from "@/assets/projects/abcdin-2.webp";
import universidadBiobio from "@/assets/projects/universidad-biobio.jpg";
import municipalidadLaPintana from "@/assets/projects/municipalidad-la-pintana.jpg";
import aeropuertoPudahuel from "@/assets/projects/aeropuerto-pudahuel.jpg";
import familyShop from "@/assets/projects/family-shop.jpg";
import mallPlaza from "@/assets/projects/mall-plaza.webp";
import salaPrensaBn from "@/assets/projects/sala-prensa-bn.webp";
import geoworking from "@/assets/projects/geoworking.jpg";
import edutecno from "@/assets/projects/edutecno.jpg";
import upita from "@/assets/projects/upita.jpg";
type FilterType = "all" | "ongoing" | "completed";
const projects = [{
  image: claroArena,
  title: "CLARO ARENA",
  category: "EN EJECUCIÓN",
  location: "Mantención Eléctrica",
  status: "ongoing"
}, {
  image: komatsu,
  title: "KOMATSU ANTOFAGASTA",
  category: "FINALIZADO",
  location: "Desarrollo y Ejecución Proyecto Eléctrico",
  status: "completed"
}, {
  image: decathlon,
  title: "DECATHLON",
  category: "EN EJECUCIÓN",
  location: "Mantención Eléctrica Tiendas",
  status: "ongoing"
}, {
  image: upita,
  title: "UPITA",
  category: "FINALIZADO",
  location: "Montaje y Mantención Eléctrica",
  status: "completed"
}, {
  image: abcdin,
  title: "ABCDIN",
  category: "FINALIZADO",
  location: "Montaje y Mantención Eléctrica",
  status: "completed"
}, {
  image: duocMaipu,
  title: "DUOC UC - SAN JOAQUÍN",
  category: "EN EJECUCIÓN",
  location: "Mantención Eléctrica",
  status: "ongoing"
}, {
  image: duocMelipilla,
  title: "DUOC UC - MELIPILLA",
  category: "EN EJECUCIÓN",
  location: "Mantención Eléctrica",
  status: "ongoing"
}, {
  image: duocPlazaVespucio,
  title: "DUOC UC - VESPUCIO",
  category: "EN EJECUCIÓN",
  location: "Mantención Eléctrica",
  status: "ongoing"
}, {
  image: duocUc,
  title: "DUOC UC - ANTONIO VARAS",
  category: "EN EJECUCIÓN",
  location: "Mantención Eléctrica",
  status: "ongoing"
}, {
  image: duocCentroMinero,
  title: "DUOC UC - CENTRO SIMULACIÓN MINERO",
  category: "FINALIZADO",
  location: "Desarrollo y Ejecución Proyecto",
  status: "completed"
}, {
  image: duocNacimiento,
  title: "DUOC UC - NACIMIENTO",
  category: "FINALIZADO",
  location: "Desarrollo y Ejecución Proyecto",
  status: "completed"
}, {
  image: duocPuertoMontt,
  title: "DUOC UC - PUERTO MONTT",
  category: "FINALIZADO",
  location: "Desarrollo y Ejecución Proyecto",
  status: "completed"
}, {
  image: universidadBiobio,
  title: "UNIVERSIDAD DEL BÍO-BÍO",
  category: "FINALIZADO",
  location: "Mantención Eléctrica",
  status: "completed"
}, {
  image: municipalidadLaPintana,
  title: "MUN. LA PINTANA",
  category: "FINALIZADO",
  location: "Normalización Eléctrica",
  status: "completed"
}, {
  image: aeropuertoPudahuel,
  title: "AEROPUERTO NUEVO PUDAHUEL",
  category: "FINALIZADO",
  location: "Desarrollo y Ejecución Proyecto Eléctrico",
  status: "completed"
}, {
  image: familyShop,
  title: "C.D. FAMILYSHOP",
  category: "FINALIZADO",
  location: "Desarrollo y Ejecución Proyecto Eléctrico",
  status: "completed"
}, {
  image: mallPlaza,
  title: "MALL PLAZA",
  category: "FINALIZADO",
  location: "Montaje y Mantención Tiendas",
  status: "completed"
}, {
  image: salaPrensaBn,
  title: "SALA DE PRENSA B&N",
  category: "FINALIZADO",
  location: "Instalación y Montaje",
  status: "completed"
}, {
  image: geoworking,
  title: "GEOWORKING",
  category: "FINALIZADO",
  location: "Desarrollo y Ejecución Proyecto Eléctrico",
  status: "completed"
}, {
  image: edutecno,
  title: "EDUTECNO",
  category: "FINALIZADO",
  location: "Mantención Eléctrica",
  status: "completed"
}];

// Sort projects: ongoing first, then completed
const sortedProjects = [...projects].sort((a, b) => {
  if (a.status === "ongoing" && b.status === "completed") return -1;
  if (a.status === "completed" && b.status === "ongoing") return 1;
  return 0;
});
const Projects = () => {
  const [filter, setFilter] = useState<FilterType>("all");
  const filteredProjects = sortedProjects.filter(project => {
    if (filter === "all") return true;
    return project.status === filter;
  });
  const ongoingCount = projects.filter(p => p.status === "ongoing").length;
  const completedCount = projects.filter(p => p.status === "completed").length;
  return <section id="proyectos" className="py-24 bg-background relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-montserrat font-bold mb-6 text-balance">NUESTROS PRINCIPALES TRABAJOS</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-inter leading-relaxed mb-8">Revisa nuestros principales proyectos realizados con los más altos estándares de calidad y seguridad</p>

          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-3">
            <Button 
              variant="outline"
              onClick={() => setFilter("all")} 
              className={`min-w-[120px] border-2 font-semibold transition-all ${filter === "all" ? "!bg-[#FF6B35] !border-[#FF6B35] !text-white hover:!bg-[#e55a2b]" : "border-muted-foreground/30 text-foreground hover:bg-muted"}`}
            >
              Todos ({projects.length})
            </Button>
            <Button 
              variant="outline"
              onClick={() => setFilter("ongoing")} 
              className={`min-w-[140px] border-2 font-semibold transition-all ${filter === "ongoing" ? "!bg-[#FF6B35] !border-[#FF6B35] !text-white hover:!bg-[#e55a2b]" : "border-muted-foreground/30 text-foreground hover:bg-muted"}`}
            >
              En Ejecución ({ongoingCount})
            </Button>
            <Button 
              variant="outline"
              onClick={() => setFilter("completed")} 
              className={`min-w-[140px] border-2 font-semibold transition-all ${filter === "completed" ? "!bg-[#FF6B35] !border-[#FF6B35] !text-white hover:!bg-[#e55a2b]" : "border-muted-foreground/30 text-foreground hover:bg-muted"}`}
            >
              Finalizados ({completedCount})
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, index) => <AnimatedSection key={project.title} animation="scale-in" delay={index * 80}>
              <Card className="overflow-hidden backdrop-blur-xl bg-white/10 border-2 border-white/20 group cursor-pointer relative h-full shadow-liquid-xl hover:shadow-liquid-2xl hover-liquid rounded-3xl">
                <div className="relative h-72 overflow-hidden">
                  <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 liquid-morph" />
                  
                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-dark-section via-dark-section/60 to-transparent opacity-60 group-hover:opacity-75 transition-opacity duration-500" />
                  
                  {/* Liquid Glass Badge */}
                  <div className="absolute top-4 left-4 z-10">
                    <span className={`${project.status === 'completed' ? 'glass-liquid-medium bg-primary/80 text-white' : 'glass-liquid-medium bg-accent/85 text-white'} px-5 py-2.5 text-xs font-bold tracking-wider rounded-full shadow-liquid-lg backdrop-blur-2xl border-2 border-white/30`}>
                      {project.category}
                  </span>
                </div>

                {/* Hover Overlay */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-20">
                  <div className="w-16 h-16 rounded-full glass-liquid-light bg-primary/90 flex items-center justify-center transform scale-0 group-hover:scale-100 liquid-bounce shadow-liquid-2xl border border-white/30">
                    <ExternalLink className="w-7 h-7 text-white" />
                  </div>
                </div>
              </div>
              
              <CardContent className="p-6 relative z-10 backdrop-blur-2xl bg-white/95 border-t-2 border-white/30">
                <h3 className="text-xl font-montserrat font-bold mb-2 group-hover:text-primary transition-colors text-foreground">
                  {project.title}
                </h3>
                <p className="text-muted-foreground font-inter leading-relaxed">
                  {project.location}
                </p>
              </CardContent>
              </Card>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
};
export default Projects;